import { Height } from "@mui/icons-material";
import { Box, Card, CardActions, CardContent, CardHeader, Typography } from "@mui/material";
import { CardMedia } from "@mui/material/node";

export const FeatureItemVideo = (props) => {
    return (

        <Card
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                alignItems: { xs: 'stretch', md: 'flex-start' }
            }}
        >
            {props.showAsImage ? (
                <CardMedia
                    component="img"
                    src={props.url}
                    sx={{
                        width: { xs: 250, md: 400 },
                        height: { xs: 250, md: 400 },
                        objectFit: 'cover'
                    }}
                    alt="Feature image"
                />
            ) : (
                <CardMedia
                    component="video"
                    src={props.url}
                    sx={{
                        width: { xs: '100%', md: '50%' },
                        height: { xs: 250, md: 400 },
                        objectFit: 'cover'
                    }}
                    loop
                    autoPlay
                    muted
                    controls={false}
                    alt="Feature video"
                />
            )}
            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                <CardContent>
                    <Typography component="div" variant="h5" sx={{my:2, px:2}}>
                        {props.title}
                    </Typography>
                    <Typography
                        variant="subtitle1"
                        component="div"
                        sx={{ color: 'text.secondary', px:2  }}
                    >
                        {props.text}
                    </Typography>
                </CardContent>
            </Box>
            <CardActions />
        </Card>
    );
};